export default __webpack_public_path__ + "static/media/7 Effective & Functional HIIT Workouts.89be6ad4.webp";